import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  VirtualConnectionTableDownstreamWorkbooksQueryVariables, VirtualConnectionTableDownstreamWorkbooksQuery, WorkbooksDisplayGridRowDataFragment, VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQueryVariables, VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQuery, WorkbookSortOrder,
  VirtualConnectionTableDownstreamWorkbooksFilteredByColumnDocument,
  VirtualConnectionTableDownstreamWorkbooksDocument,
} from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  getRowDataForWorkbook,
  WorkbooksDisplayGrid,
  WorkbooksDisplayGridRowData,
} from '../sharedDisplayGrid/WorkbooksDisplayGrid';
import { WorkbooksValidSortFields } from '../sorting/sortProviders/WorkbooksGridSortProvider';

type QueryVariables = VirtualConnectionTableDownstreamWorkbooksQueryVariables;
type QueryResults = VirtualConnectionTableDownstreamWorkbooksQuery;
type QueryResultListNode = WorkbooksDisplayGridRowDataFragment;
type GridRowData = WorkbooksDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQueryVariables;
type QueryResultsWithFilter = VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQuery;
type QueryResultListNodeWithFilter = WorkbooksDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  return virtualConnection ? virtualConnection.downstreamWorkbooksConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  const virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
  const column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
  return column ? column.downstreamWorkbooksConnection : null;
}

export type VirtualConnectionTableDownstreamWorkbooksQueryGridProps =
  GridSortProps<WorkbooksValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionTableDownstreamWorkbooksQueryGrid(props: VirtualConnectionTableDownstreamWorkbooksQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamWorkbooksLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredWorkbooksLineageGridMessage();

  return props.filteredColumnId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamWorkbooksFilteredByColumnDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedColumnId: props.filteredColumnId,
        orderBy: props.orderBy as WorkbookSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForWorkbook}
    >
      {({ rowStore }) => <WorkbooksDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamWorkbooksDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as WorkbookSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForWorkbook}
    >
      {({ rowStore }) => <WorkbooksDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
